
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.891 56.25h3.843v-5.625h7.685a9.738 9.738 0 006.79-2.749 9.271 9.271 0 002.817-6.626v-2.4l4.45-1.446a1.93 1.93 0 00.728-.431 1.87 1.87 0 00.465-.697 1.833 1.833 0 00-.154-1.615l-5.49-8.93v-5.106c-.004-4.474-1.828-8.763-5.07-11.927-3.241-3.164-7.636-4.943-12.221-4.948H3.128V7.5h9.606c3.566.004 6.984 1.388 9.505 3.849 2.522 2.46 3.94 5.796 3.944 9.276v5.625c0 .34.096.673.275.964l4.528 7.372-3.49 1.135a1.92 1.92 0 00-.951.683 1.84 1.84 0 00-.362 1.096v3.75a5.563 5.563 0 01-1.69 3.976 5.843 5.843 0 01-4.074 1.649h-9.606c-.51 0-.999.197-1.359.55a1.85 1.85 0 00-.563 1.325v7.5z"}}),_c('path',{attrs:{"d":"M22.34 22.5h-7.685v3.75h7.685V22.5zm18.576 24.782a13.146 13.146 0 003.31-4.424 12.856 12.856 0 001.172-5.358c0-1.846-.4-3.672-1.172-5.358a13.144 13.144 0 00-3.31-4.424l-2.563 2.794a9.391 9.391 0 012.364 3.16 9.183 9.183 0 01.837 3.827 9.183 9.183 0 01-.837 3.827 9.391 9.391 0 01-2.364 3.16l2.563 2.796z"}}),_c('path',{attrs:{"d":"M46.549 54a20.756 20.756 0 006.22-7.277A20.222 20.222 0 0055 37.5c0-3.202-.764-6.36-2.23-9.223A20.756 20.756 0 0046.549 21l-2.306 3a16.98 16.98 0 015.092 5.953 16.544 16.544 0 011.826 7.548c0 2.62-.625 5.204-1.826 7.547a16.981 16.981 0 01-5.092 5.954L46.55 54z"}})])
          )
        }
      }
    